export default {
    login_username: 'Username',
    login_password: 'Password',
    login_required_filed: 'Required field',
    login_forgot_password: 'Forgot Password?',
    login_sign_in: 'Sign In',
    login_sign_in_with_google: 'Sign In With Google',
    login_sign_in_with_username: 'Sign in with Username',
    page_not_found: 'Oops! We´ve hit a speed bump',
    page_not_found_message: 'The page you are looking for seems to be missing. If you need a ride someplace else, try one of the buttons on the left',
};


